import * as Yup from "yup";
import { validarCuilCuit } from "../../../../../util/cuilcuit";

export const observacionesValidation = Yup.object({
  observacionesGenerales: Yup.string().required("Campo obligatorio").nullable(),
  descripcionActividadEstablecimiento: Yup.string()
    .required("Campo obligatorio")
    .nullable(),
});

const maxValueSqlInteger = 2147483647;
const maxValueSqlIntegerAsString = new Intl.NumberFormat("es-AR").format(
  maxValueSqlInteger
);

export const cabeceraValidation = Yup.object({
  cantidadTrabajadoresProduccion: Yup.number()
    .min(0, "La cantidad debe ser un número entero positivo")
    .max(
      maxValueSqlInteger,
      `La cantidad debe ser menor a ${maxValueSqlIntegerAsString}`
    )
    .integer("Ingresar números sin coma")
    .required("Campo obligatorio")
    .nullable(),
  cantidadTrabajadoresEventualesProduccion: Yup.number()
    .min(0, "La cantidad debe ser un número entero positivo")
    .max(
      maxValueSqlInteger,
      `La cantidad debe ser menor a ${maxValueSqlIntegerAsString}`
    )
    .integer("Ingresar números sin coma")
    .required("Campo obligatorio")
    .nullable(),
  cantidadTrabajadoresAdministracion: Yup.number()
    .min(0, "La cantidad debe ser un número entero positivo")
    .max(
      maxValueSqlInteger,
      `La cantidad debe ser menor a ${maxValueSqlIntegerAsString}`
    )
    .integer("Ingresar números sin coma")
    .required("Campo obligatorio")
    .nullable(),
  cantidadTrabajadoresEventualesAdministracion: Yup.number()
    .min(0, "La cantidad debe ser un número entero positivo")
    .max(
      maxValueSqlInteger,
      `La cantidad debe ser menor a ${maxValueSqlIntegerAsString}`
    )
    .integer("Ingresar números sin coma")
    .required("Campo obligatorio")
    .nullable(),
  sePuedeFumar: Yup.bool().nullable(),
  espacioParaFumar: Yup.bool().nullable(),
  responsableEmpresa: Yup.string().required("Campo obligatorio").nullable(),
  responsableMedicina: Yup.string()
    .nullable(),
  responsableSH: Yup.string()
    .required("Campo obligatorio")
    .nullable(),
  contacto: Yup.string().required("Campo obligatorio").nullable(),
});

export const dialogValidation = Yup.object({
  cuit: Yup.string()
    .required("Campo obligatorio")
    .test({
      name: "cuitValido",
      message: "Debe ingresar un CUIT válido",
      test: function (value) {
        if (value) {
          return validarCuilCuit(value, true, true);
        }
      },
    }),
  ciiu: Yup.string().required("Campo obligatorio").nullable(),
  cantidadEmpleados: Yup.number()
    .integer("Debe ser un número entero")
    .min(0, "No puede ser negativo")
    .max(99999, "Se supero el número maximo")
    .required("Campo obligatorio"),
});
